export enum Social {
  FACEBOOK = 'Facebook',
  FACEBOOK_API_KEY = 'FacebookAPIKey',
  INSTAGRAM = 'Instagram',
  LINKEDIN = 'LinkedIn',
  TWITTER = 'Twitter',
  YOUTUBE = 'YouTube',
  TIKTOK = 'TikTok',
}